import { ICustomButtonPaneProps } from './ICustomButtonPaneProps';
import {
    IPropertyPaneField,
    PropertyPaneFieldType
} from '@microsoft/sp-webpart-base';

export class CustomButtonPane implements IPropertyPaneField<ICustomButtonPaneProps>{

    public type: PropertyPaneFieldType = PropertyPaneFieldType.Custom;
    public targetProperty: string;
    public properties: any;
    private elem: HTMLElement;
    constructor(targetProperty: string, properties: ICustomButtonPaneProps) {
        this.targetProperty = targetProperty;
        this.properties = {
            text: properties.text,
            onRender: this.onRender.bind(this)
        };
    }

    private onRender(elem: HTMLElement){
        this.elem.innerHTML = '<button  type="button" href={this.context.pageContext.site.absoluteUrl}>';
    }
}